export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13372.87d19efd.jpg";